// extracted by mini-css-extract-plugin
export default {"mainPageContent":"styles_mainPageContent__T-PJM","pageContent":"styles_pageContent__OE3p0"};